module.exports = __webpack_public_path__ + "img/3.6e4e3af4.png";